/** Bump when tour content changes; keep in sync with server `constants/productTour.ts`. */
export const CURRENT_PRODUCT_TOUR_VERSION = 1;
